(function () {
  function easeOut(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function setFill(fill, value) {
    if (!fill) return;
    var w = value + '%';
    fill.style.setProperty('--vb-fill', w);
    fill.style.width = w;
    fill.style.maxWidth = w;
  }

  function animateStat(el, delay) {
    var target = parseFloat(el.getAttribute('data-vb-stat-target') || '0');
    var num = el.querySelector('[data-vb-stat-num]');
    var fill = el.querySelector('[data-vb-stat-fill]');
    if (!num || el.dataset.done === '1') return;
    el.dataset.done = '1';
    if (isNaN(target)) target = 0;

    setFill(fill, 0);

    setTimeout(function () {
      var duration = 2000;
      var start = performance.now();
      function frame(now) {
        var p = Math.min((now - start) / duration, 1);
        var current = easeOut(p) * target;
        num.textContent = Math.round(current) + '%';
        setFill(fill, current);
        if (p < 1) requestAnimationFrame(frame);
        else {
          num.textContent = Math.round(target) + '%';
          setFill(fill, target);
        }
      }
      requestAnimationFrame(frame);
    }, delay);
  }

  function init(root) {
    var items = root.querySelectorAll('[data-vb-stat]');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el, i) {
        animateStat(el, i * 150);
      });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          items.forEach(function (el, i) {
            animateStat(el, i * 150);
          });
          obs.disconnect();
        });
      },
      { threshold: 0.15 }
    );
    obs.observe(root);
  }

  function boot() {
    document.querySelectorAll('[data-vb-pdp-results]').forEach(init);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-vb-pdp-results]');
    if (r) init(r);
  });
})();
